const topics = {
    'Fantasy': {
        id: 'Fantasy',
        name: 'Fantasy',
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg',
        quizIds: [
            'Fantasy World Trivia', 
            'Fantasy Adventure Quiz', 
            'Fantasy Creatures Quiz', 
            'Fantasy Realms Quiz'
        ]
    },
    'Nature': {
        id: 'Nature',
        name: 'Nature',
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg',
        quizIds: [
            'Nature Wonders Quiz', 
            'Nature Landscapes Quiz', 
            'Wildlife Quiz', 
            'Nature Secrets Quiz'
        ]
    },
    'Society': {
        id: 'Society',
        name: 'Society',
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg',
        quizIds: [
            'Social Dynamics Quiz', 
            'Society and Culture Quiz', 
            'Human Behavior Quiz', 
            'Social Norms Quiz'
        ]
    }
};

export default topics;
